export default __webpack_public_path__ + "static/media/yellow_audio.7205c38b.mp3";